<form [formGroup]="fG">
  <ejs-slider
    #slider
    [formControlName]="fCN"
    [type]="type"
    [enabled]="!disabled"
    [min]="min"
    [max]="max"
    [ticks]="ticks"
    [step]="step"
    [tooltip]="tooltip"
    (tooltipChange)="tooltipChange($event)"
    (renderingTicks)="tooltipChange($event)">
  </ejs-slider>
  @if (hasErrorField) {
    <div class="error-label" role="alert">
      {{ errorText && fG.controls[fCN].invalid && fG.controls[fCN].dirty ? errorText : '' }}
    </div>
  }
</form>
